export const actions = {
  async getOffers(state) {
    const res = await this.$axios.get('/pages/offers')
    return res.data
  },
  async getBoxes(state) {
    const res = await this.$axios.get('/pages/boxes')
    return res.data
  },
  async getGourtmet(state) {
    const res = await this.$axios.get('/pages/gourmet-products')
    return res.data
  },

  async getWineCountries(state, payload) {
    const res = await this.$axios.get('/pages/' + payload)
    return res.data
  },
  async getWinesAlcohol(state) {
    const res = await this.$axios.get('/pages/alcohols')
    return res.data
  },
  async getSearchHero(state) {
    const res = await this.$axios.get('/pages/general-search')
    return res.data
  },
}
